import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAdFoxBannerClick, trackAdFoxBannerView } from './tracking';
import { AdFoxBanner } from 'shared/components/AdfoxBanner';
import { selectSource } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';
import { AdfoxContextProvider, AdfoxContextProviderProps } from 'shared/utils/AdfoxContext';

interface IAdFoxBannerContainerProps extends Omit<AdfoxContextProviderProps, 'children'> {
  position?: number;
  onError?(): void;
  onStub?(): void;
  onClick?(event: MouseEvent): void;
  bannerName: string;
}

export const AdFoxBannerContainer: React.FC<IAdFoxBannerContainerProps> = ({
  position,
  onStub,
  onError,
  bannerName,
  onClick,
  ...props
}) => {
  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);

  const handleClick = React.useCallback(
    (event: MouseEvent) => {
      trackAdFoxBannerClick(jsonQuery, bannerName, source);
      onClick?.(event);
    },
    [jsonQuery, bannerName, onClick, source],
  );

  const handleShow = React.useCallback(() => {
    trackAdFoxBannerView(jsonQuery, bannerName, source);
  }, [jsonQuery, bannerName, source]);

  return (
    <AdfoxContextProvider {...props}>
      <AdFoxBanner
        position={position}
        onStub={onStub}
        onClick={handleClick}
        onView50Percent={handleShow}
        onError={onError}
      />
    </AdfoxContextProvider>
  );
};
